'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { Icon } from '../icon';
import { AvatarRootContext } from './context/avatar-root.context';
import { avatarBadgeRecipe } from './styles/avatar-badge.styles';
import type { AvatarBadgePropsInterface } from './types/avatar-badge.types';

/**
 * @since 10.0.0
 */
export const AvatarBadge = forwardRef<HTMLDivElement, AvatarBadgePropsInterface>(
  (props, forwardedRef) => {
    const { css: cssProp, className, icon, tone = 'hero', ...rest } = props;

    const { size = 'lg' } = useContext(AvatarRootContext);

    const styles = css(avatarBadgeRecipe.raw({ tone, size }), cssProp);

    return (
      <div
        ref={forwardedRef}
        data-c11n-component="Avatar.Badge"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', styles, className)}
        {...rest}
      >
        <Icon>{icon}</Icon>
      </div>
    );
  },
);

AvatarBadge.displayName = 'Avatar.Badge';
